import { ReactNode } from 'react'
import InfoTooltip from './InfoTooltip'

interface FieldProps {
  label: string
  children: ReactNode
  className?: string
  asana?: boolean
  // Highlight this field as needing attention - shown as a subtle amber tint on the input.
  // Used for empty fields that block downstream automation (go-live date, stakeholders, etc.)
  needed?: boolean
  // Optional element rendered at the right of the label (e.g. Asana link/unlink button)
  action?: ReactNode
  // Optional explanatory (i) tooltip shown next to the label.
  info?: ReactNode
}

export default function Field({ label, children, className = '', asana, needed, action, info }: FieldProps) {
  return (
    <div className={className}>
      <label className="flex items-center gap-1.5 text-xs font-semibold text-slate-500 uppercase mb-1.5">
        {label}
        {asana && <span className="w-1.5 h-1.5 bg-rose-400 rounded-full" title="Synced from Asana" />}
        {needed && <span className="w-1.5 h-1.5 bg-amber-400 rounded-full" title="Needed to continue" />}
        {info && <InfoTooltip>{info}</InfoTooltip>}
        {action && <span className="ml-auto normal-case">{action}</span>}
      </label>
      <div className={needed ? 'rounded-lg ring-1 ring-amber-200' : ''}>
        {children}
      </div>
    </div>
  )
}

export const inputClass = 'w-full px-3 py-2 border border-slate-200 rounded-lg text-sm'
